// Core Modules
import { inject } from '@angular/core';
import { CanActivateFn, RouterStateSnapshot } from '@angular/router';

// Services
import { EditAudienceService } from '@edit-audience/services/edit-audience.service';

export const UnsavedAudienceDetectorGuard: CanActivateFn = (_, state: RouterStateSnapshot) => {
  // Injectors
  const editAudienceService = inject(EditAudienceService);

  if (!editAudienceService.isCriteriaUnsaved) return true;
  editAudienceService.openUnsavedAudienceModal(state.url).catch(() => {
    console.log('Unsaved audience modal cancelled');
  });
  return !editAudienceService.isCriteriaUnsaved;
};
